module.exports = __webpack_public_path__ + "img/yan6.4ede80b2.png";